module.exports = "<script ng-bind-html=\"richJson()\", type=\"application/ld+json\">\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/richVenueCard/template.html
// module id = 863
// module chunks = 1